import React from "react";
import Languages from "../../../translations";

const StrongIdentificationNewUserRedirectView = () => {

return(<div>{Languages.useStrongIdentification}</div>);

}

export default StrongIdentificationNewUserRedirectView;